import * as React from 'react';
import { History } from 'history';
import Model from './quizanswer-model';
import BaseChecklistCard from '../base/base-checklistcard.component';
import { align } from '../../services/app.service';

interface IProps { 
  history: History;
  caption?: string;
  questionId: number;
  readOnly?: boolean
  currentId?: any;
  onLoad?: (data: any) => void;
  cardCount?: number;
  cardBorderRadius?: number;
  cardAlign?: align;
}

interface IState {
}

export default class QuizanswerChecklistCard extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render(): React.ReactNode {
    return (
      <BaseChecklistCard history={this.props.history} caption={this.props.caption} endPointFilter={Model.endPointFilter+this.props.questionId} model={Model} readOnly={this.props.readOnly} currentId={this.props.currentId} onLoad={this.props.onLoad} cardCount={this.props.cardCount} cardBorderRadius={this.props.cardBorderRadius} cardAlign={this.props.cardAlign} disableBackButton disableCard/>
    );
  }
}
